import {useContext} from 'react';

import {FormContext} from '../contexts';

/**
 * A custom hook that provides access to the form context values and methods.
 * This hook must be used within a FormProvider component to access the form state,
 * validation methods, and other form-related functionality. It returns the entire
 * form context object that was passed down through the React context API.
 *
 * @returns The form context object containing form state, methods, and configuration.
 *
 * @throws Will throw an error if used outside of a FormProvider component.
 *
 * @example
 * ```tsx
 * const MyFormComponent = () => {
 *   const { register, handleSubmit, formState } = useFormContext();
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register('fieldName')} />
 *       {formState.errors.fieldName && <span>This field is required</span>}
 *     </form>
 *   );
 * };
 * ```
 */
export const useFormContext = () => useContext(FormContext);